import { Injectable } from '@angular/core';
import { EventsService } from './events.service';

@Injectable({
    providedIn: 'root',
})
export class ZoomLevelService {
    zoomLevel = '100%';

    constructor(private events: EventsService) {}

    changeZoom() {
        if (window.innerWidth < 640) {
            this.zoomLevel = '50%';
        } else {
            this.zoomLevel = '100%';
        }
        this.events.publish('cdr');
    }

    decreaseZoom() {
        let zoom = +this.zoomLevel.substring(0, this.zoomLevel.length - 1);
        if (zoom >= 20) {
            zoom = zoom - 10;
        }
        this.zoomLevel = zoom.toString() + '%';
        this.events.publish('cdr');
    }

    increaseZoom() {
        let zoom = +this.zoomLevel.substring(0, this.zoomLevel.length - 1);
        if (zoom < 300) {
            zoom = zoom + 10;
        }
        this.zoomLevel = zoom.toString() + '%';
        this.events.publish('cdr');
    }

    getTouchDistance(event: TouchEvent): number {
        if (event.touches.length < 2) return 0;

        const touch1 = event.touches[0];
        const touch2 = event.touches[1];

        const dx = touch1.clientX - touch2.clientX;
        const dy = touch1.clientY - touch2.clientY;

        return Math.sqrt(dx * dx + dy * dy);
    }
}
